"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpotMarkets = exports.getFutureMarkets = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
/**
 *
 * @returns 获取合约交易市场信息
 */
const getFutureMarkets = () => {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost;
    const url = host + "/future_markets/";
    return trade_utils_lib_1.Network.get({ url });
};
exports.getFutureMarkets = getFutureMarkets;
const getSpotMarkets = () => {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost;
    const url = host + "/spot_markets/";
    return trade_utils_lib_1.Network.get({ url });
};
exports.getSpotMarkets = getSpotMarkets;
